// video section
import jQuery from 'jquery';
(function($) {
    const videoContainers = $(".video");

    videoContainers.each(function () {
        const container = $(this);
        const videoElement = container.find("video")[0];

        // YouTube: click-to-play via poster overlay.
        // Creates a fresh iframe with src set before DOM insertion so Safari's CSP
        // does not block the cross-origin navigation from an about:blank iframe.
        if (!videoElement) {
            const poster = container.find('.youtube-poster');
            const iframe = container.find('.youtube-iframe');

            if (poster.length && iframe.length) {
                poster.on('click', function () {
                    const newIframe = document.createElement('iframe');
                    newIframe.src = iframe.data('src') + '&autoplay=1';
                    ['class', 'title', 'frameborder', 'allow', 'referrerpolicy'].forEach(function (attr) {
                        const val = iframe.attr(attr);
                        if (val) newIframe.setAttribute(attr, val);
                    });
                    newIframe.allowFullscreen = true;
                    iframe[0].replaceWith(newIframe);
                    poster.hide();
                });
            }
            return;
        }

        const initButton = container.find(".video-init");
        const autoplayEnabled = container.data("properties").autoplay || false;

        videoElement.addEventListener("play", function () {
            // Reveal native controls on first play so pause/volume/scrubber are available
            videoElement.setAttribute('controls', '');
            if (initButton.length) {
                initButton.css("display", "none");
            }
        });

        videoElement.addEventListener("pause", function () {
            // Keep controls visible when paused so the scrubber/volume remain accessible
            if (initButton.length) {
                initButton.css("display", "inline-flex");
            }
        });

        if (initButton.length) {
            initButton.on("click", function () {
                videoElement.play();
            });
        }

        // Pause/play based on viewport visibility
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && autoplayEnabled) {
                        videoElement.play();
                    } else {
                        videoElement.pause();
                    }
                });
            },
            { root: null, threshold: 0.5 }
        );

        observer.observe(container[0]);
    });
})(jQuery);
